var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('panelMember',{attrs:{"panelMemberId":_vm.$route.params.panelMemberId},on:{"submit":function($event){return _vm.update($event)},"cancel":function($event){return _vm.cancel($event)},"clear":function($event){return _vm.clear($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }